import urljoin from 'url-join';

import { APP_ROUTE_BASENAME } from './Capacitors/constant';

const getImagePathString = (path) => {
  if (path.startsWith('http')) {
    return path;
  } else {
    return urljoin(getPublicPath(), path);
  }
};

export const getImagePath = (path) => {
  const imagePath = path || '';
  if (Array.isArray(imagePath)) {
    return imagePath.map((p) => getImagePathString(p));
  } else {
    return getImagePathString(imagePath);
  }
};

export const getPublicPath = () => {
  return process.env.PUBLIC_PATH || '/';
};

export const getRouteBaseName = () => APP_ROUTE_BASENAME || getPublicPath();
